import React, { useEffect, useState } from 'react';
import { ReviewReviewerList } from 'aws-sdk/clients/awsdlomni';
import { Alert, Header, SpaceBetween, Spinner, TextContent } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { createReviewDetailsLink } from 'src/routes';
import { getReview } from 'src/api/notifications';
import { NEEDS_MORE_DATA, PENDING_CONSUMER_REVIEW } from 'src/commons/constants';

export interface ReviewLinksProps {
  reviewers: ReviewReviewerList;
}

export function ReviewLinks(props: ReviewLinksProps) {
  const [loadingReviews, setLoadingReviews] = useState(false);
  const [custodianComments, setCustodianComments] = useState<string[]>([]);

  const reviewerKey = props.reviewers?.map((r) => `${r.reviewId}:${r.reviewStatus}`).join(',') ?? '';

  useEffect(() => {
    const fetchReviewContent = async () => {
      const pendingReviews = props.reviewers?.filter((review) => review.reviewStatus === PENDING_CONSUMER_REVIEW);

      if (!pendingReviews?.length) return;

      try {
        setLoadingReviews(true);
        const reviews = await Promise.all(pendingReviews.map((review) => getReview({ reviewId: review.reviewId })));

        const comments = reviews
          .map(
            (result) =>
              result?.review?.reviewRecordsHistory
                ?.slice()
                .reverse()
                .find((record) => record.action === NEEDS_MORE_DATA)?.comment,
          )
          .filter((comment) => comment !== undefined);

        setCustodianComments([...new Set(comments)]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingReviews(false);
      }
    };

    fetchReviewContent();
  }, [reviewerKey]);

  if (!props.reviewers?.length) return null;

  return (
    <Header variant='h3'>
      Related Reviews:{' '}
      <SpaceBetween size='xxs' direction='vertical'>
        <SpaceBetween size='xxs' direction='horizontal'>
          {props.reviewers.map((r) => (
            <Link key={r.reviewId} href={createReviewDetailsLink(r.reviewId)} external>
              {r.name ?? r.reviewId}
            </Link>
          ))}
        </SpaceBetween>
        {loadingReviews ? (
          <Spinner size='normal' />
        ) : custodianComments.length > 0 ? (
          <Alert header='Additional information requested by custodian' type='warning'>
            <TextContent>
              <ul>
                {custodianComments.map((comment) => (
                  <li key={comment}>{comment}</li>
                ))}
              </ul>
            </TextContent>
          </Alert>
        ) : null}
      </SpaceBetween>
    </Header>
  );
}
